class FormulatedIconsSlider extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute('data-swiper')) return;

    this.handleSwiperLoaded = this.handleSwiperLoaded || this.initialize.bind(this);
    this.handleViewportChange = this.handleViewportChange || this.reinitialize.bind(this);
    this.mobileMediaQuery = this.mobileMediaQuery || window.matchMedia('(max-width: 768px)');
    this.reducedMotionMediaQuery =
      this.reducedMotionMediaQuery || window.matchMedia('(prefers-reduced-motion: reduce)');

    this.addMediaQueryListener(this.mobileMediaQuery, this.handleViewportChange);
    this.addMediaQueryListener(this.reducedMotionMediaQuery, this.handleViewportChange);

    if (window.Swiper) {
      this.initialize();
      return;
    }

    document.body.addEventListener('swiper-loaded', this.handleSwiperLoaded);
  }

  disconnectedCallback() {
    document.body.removeEventListener('swiper-loaded', this.handleSwiperLoaded);
    this.removeMediaQueryListener(this.mobileMediaQuery, this.handleViewportChange);
    this.removeMediaQueryListener(this.reducedMotionMediaQuery, this.handleViewportChange);

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    this.classList.remove('is-mobile-autoplay');
  }

  initialize() {
    if (this.swiper || typeof Swiper === 'undefined') return;

    const slider = this.querySelector('.swiper');
    const slides = this.querySelectorAll('.swiper-slide');

    if (!slider || slides.length <= 1) {
      document.body.removeEventListener('swiper-loaded', this.handleSwiperLoaded);
      return;
    }

    const mobileGap = Number(this.dataset.gapMobile);
    const desktopGap = Number(this.dataset.gapDesktop);
    const shouldAutoplay = this.shouldAutoplayOnMobile();

    this.classList.toggle('is-mobile-autoplay', shouldAutoplay);

    this.swiper = new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: Number.isNaN(mobileGap) ? 20 : mobileGap,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      grabCursor: true,
      allowTouchMove: true,
      centerInsufficientSlides: !shouldAutoplay,
      loop: shouldAutoplay,
      loopAdditionalSlides: shouldAutoplay ? slides.length : 0,
      speed: shouldAutoplay ? 3200 : 300,
      autoplay: shouldAutoplay
        ? {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
          }
        : false,
      breakpoints: {
        769: {
          spaceBetween: Number.isNaN(desktopGap) ? 56 : desktopGap
        }
      }
    });

    document.body.removeEventListener('swiper-loaded', this.handleSwiperLoaded);
  }

  reinitialize() {
    if (!this.swiper) return;

    this.swiper.destroy(true, true);
    this.swiper = null;
    this.initialize();
  }

  shouldAutoplayOnMobile() {
    return this.mobileMediaQuery.matches && !this.reducedMotionMediaQuery.matches;
  }

  addMediaQueryListener(mediaQuery, handler) {
    if (!mediaQuery) return;

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handler);
      return;
    }

    mediaQuery.addListener(handler);
  }

  removeMediaQueryListener(mediaQuery, handler) {
    if (!mediaQuery) return;

    if (typeof mediaQuery.removeEventListener === 'function') {
      mediaQuery.removeEventListener('change', handler);
      return;
    }

    mediaQuery.removeListener(handler);
  }
}

if (!customElements.get('formulated-icons-slider')) {
  customElements.define('formulated-icons-slider', FormulatedIconsSlider);
}
